import React from "react";
import BookingForm from "./BookingForm";

const BookRoom = () => {
  return (
    <div className="h-[700px] text-center py-[10px] ">
      <div
        className="relative pt-[30px] h-full  bg-cover bg-center"
        style={{
          backgroundImage: `url('https://nhatnguyenhotel.vn/wp-content/uploads/2024/10/z5951286414744_490d1ce1532215395a6547dea06af5bc-534x800.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 pt-[30px] ">
          <h2 className="font-cormorant text-[35px] text-white">
            ĐẶT PHÒNG NGAY
          </h2>
          <p className="text-white">
            Cảm ơn Quý khách đã chọn Đế Vương Hotel. Quý khách cần hỗ trợ thêm,
            vui lòng điền vào mẫu thông tin bên dưới.
          </p>
          <div className="flex justify-center mt-4">
            <BookingForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookRoom;
